const project_color = localStorage.getItem("project_color");
export const colors = {
  primary: project_color != "undefined" ? project_color : "black", // Example primary color (blue)
  secondary: "#004F57", // Example secondary color (red) #D33537
};

export default colors;
